import type { OwaDate } from 'owa-datetime';
import { addDays, differenceInDays } from 'owa-datetime';
import { CACHE_SIZE_IN_PAGES, PAGE_SIZE_IN_DAYS } from '../constants';

export function scaleRangeAsCacheSize(start: OwaDate, end: OwaDate): OwaDate {
    const cacheSizeInDays = CACHE_SIZE_IN_PAGES * PAGE_SIZE_IN_DAYS;
    return differenceInDays(end, start) > cacheSizeInDays ? addDays(start, cacheSizeInDays) : end;
}
